'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _each2 = require('lodash/each');

var _each3 = _interopRequireDefault(_each2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ = {
    each: _each3.default
};

function cbChatDirective($window, $interval, ApiService, $timeout) {
    return {
        restrict: 'A',
        scope: true,
        controller: 'chatController',
        controllerAs: 'chat',
        link: cbStripChatV1Link
    };

    function cbStripChatV1Link(scope, element, attr) {
        var intervalAutoStart = undefined;
        function autoStartChat() {
            if (_angular2.default.isDefined(attr.autoStart) && attr.autoStart === 'true' && _angular2.default.isDefined(attr.flow)) {
                intervalAutoStart = $interval(function () {
                    if ($window.Application && typeof $window.Application.HandleMouseClick === 'function') {
                        scope.chat.start(undefined, null, attr.flow);
                        $interval.cancel(intervalAutoStart);
                    }
                }, 250);
            } else if (_angular2.default.isDefined(attr.autoStart) && !_angular2.default.isDefined(attr.flow)) {
                throw new Error('When auto-start is the attribute flow is required');
            }
        }

        $timeout(autoStartChat, 750);

        _.each(element.find('.chat__intro'), function (chatIntro) {
            chatIntro = _angular2.default.element(chatIntro);
            var _gettersAndSetters = addChatIntroGettersAndSetters(chatIntro);
            var gettersAndSetters = ApiService.registerGettersAndSetters(_gettersAndSetters);

            ApiService.attach({
                'chat-intro': gettersAndSetters
            });
        });

        _.each(element.find('.chat__content .chat__answers .chat__btn'), function (chatBtn) {
            addChatBtnCbFunctions(chatBtn);
        });

        scope.$on('$destroy', function () {
            if (_angular2.default.isDefined(intervalAutoStart)) {
                $interval.cancel(intervalAutoStart);
            }
        });
    }

    function addChatBtnCbFunctions(element) {
        var _gettersAndSetters = addChatBtnGettersAndSetters(element);
        var gettersAndSetters = ApiService.registerGettersAndSetters(_gettersAndSetters);

        ApiService.attach({
            'chat-btn': gettersAndSetters
        });
    }

    function addChatIntroGettersAndSetters(element) {
        var chatIntro = {};

        Object.defineProperty(chatIntro, 'title', {
            get: function get() {
                return element.find('.heading-page-title').html();
            },
            set: function set(newValue) {
                element.find('.heading-page-title').html(newValue);
            }
        });

        Object.defineProperty(chatIntro, 'subtitle', {
            get: function get() {
                return element.find('.heading-page-subtitle').html();
            },
            set: function set(newValue) {
                element.find('.heading-page-subtitle').html(newValue);
            }
        });

        Object.defineProperty(chatIntro, 'content', {
            get: function get() {
                return element.find('.chat__intro-content').html();
            },
            set: function set(newValue) {
                element.find('.chat__intro-content').html(newValue);
            }
        });

        return chatIntro;
    }

    function addChatBtnGettersAndSetters(element) {
        var chatBtn = {};

        Object.defineProperty(chatBtn, 'btn', {
            get: function get() {
                return _angular2.default.element(element).html();
            },
            set: function set(newValue) {
                _angular2.default.element(element).html(newValue);
            }
        });

        return chatBtn;
    }

    function addEventListenersForMobileKeyboard() {
        $window.addEventListener('keydown', mobileKeyboardEnter, true);
    }

    function removeEventListenersForMobileKeyboard() {
        $window.removeEventListener('keydown', mobileKeyboardEnter);
    }

    function mobileKeyboardEnter(event) {
        if (event.key === 'Enter') {
            // focus on chat top
            if ($window.gWebClient) {
                $window.gWebClient.SubmitUserMessage(null);
            }
            $window.scrollTo(0, element[0].getBoundingClientRect().top + $window.scrollY);
            removeEventListenersForMobileKeyboard();
            scope.$apply();
        }
    }
}

cbChatDirective.$inject = ['$window', '$interval', 'ApiService', '$timeout'];

exports.default = cbChatDirective;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/chat/cb-chat.directive.js
// module id = 867
// module chunks = 0